import { Routes } from '@angular/router';
import { HomeComponent } from './component/home.component/home.component';
import { ProjectsComponent } from './component/projects.component/projects.component';
import { ProjectDetailComponent } from './component/project-detail.component/project-detail.component';
import { BlogComponent } from './component/blog.component/blog.component';
import { BlogPostComponent } from './component/blog-post.component/blog-post.component';
import { NotFoundComponent } from './component/not-found.component/not-found.component';
import { ResumeComponent } from './component/resume/resume';
import { TestComponent } from './component/test/test';
import { ResumeOneComponent } from './component/resume-one/resume-one';
import { ResumeTrComponent } from './component/resume-tr-component/resume-tr-component';
import { ResumeOneTrComponent } from './component/resume-one-tr-component/resume-one-tr-component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'projects', component: ProjectsComponent },
  { path: 'projects/:slug', component: ProjectDetailComponent },
  { path: 'blog', component: BlogComponent },
  // { path: 'blog/:slug', component: BlogPostComponent },
  { path: "resume", component: ResumeComponent },
  { path: "resume-tr", component: ResumeTrComponent },
  {path: "resume-one", component: ResumeOneComponent},
  {path: "resume-one-tr", component: ResumeOneTrComponent},
  { path: "test", component: TestComponent },
  { path: '**', component: NotFoundComponent },
];